import colors from '@/styles/themes/brand/colors';
import FontSizes from '@/styles/themes/brand/fontSizes';
import FontWeights from '@/styles/themes/brand/fontWeights';

const style = {
  container: {
    width: '100%',
    bg: colors.secondary,
    py: '12px',
    px: { base: '16px', md: '24px' },
    '&[data-variant="info"]': {
      bg: colors.secondary,
    },
    '&[data-variant="warning"]': {
      bg: colors.warning,
    },
    '&[data-variant="error"]': {
      bg: colors.error,
    },
    '&[data-variant="success"]': {
      bg: colors.success,
    },
  },
  content: {
    maxW: '100%',
    mx: '0',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    zIndex: 9999,
  },
  '.app-alertmessage': {
    position: 'relative',
    zIndex: 9999,
  },
  icon: {
    width: '20px',
    height: '20px',
    color: colors.text.light,
    flexShrink: 0,
  },
  message: {
    color: colors.text.light,
    fontSize: FontSizes.small,
    fontWeight: FontWeights.medium,
    textAlign: 'center',
    flex: 1,
  },
  closeButton: {
    color: colors.text.light,
    position: { base: 'relative', md: 'absolute' },
    _rtl: { left: 0 },
    _ltr: { right: 0 },
    _hover: {
      bg: 'rgba(255, 255, 255, 0.1)',
    },
    '& svg': {
      width: '12px',
      height: '12px',
    },
  },
};

export default style;
